"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinionSkillNames = void 0;
exports.MinionSkillNames = [
    "Mining1",
    "Mining2",
    "Mining3",
    "Building1",
    "Building2",
    "Building3",
    "Farming1",
    "Farming2",
    "Farming3",
    "Ranching1",
    "Ranching2",
    "Researching1",
    "Researching2",
    "Researching3",
    "Cooking1",
    "Cooking2",
    "Arting1",
    "Arting2",
    "Arting3",
    "Hauling1",
    "Hauling2",
    "Suits1",
    "Technicals1",
    "Technicals2",
    "Engineering1",
    "Basekeeping1",
    "Basekeeping2",
    "Astronauting1",
    "Astronauting2",
    "Medicine1",
    "Medicine2",
    "Medicine3"
];
//# sourceMappingURL=skills.js.map